import cx from 'classnames';
import {memo, useCallback} from 'react';
import {filterGuests} from '~/ViewInvitation/components/Guestlist/actions/actions';
import {useGuestlistDataContext} from '~/ViewInvitation/components/Guestlist/hooks/useGuestlistDataContext';
import type {RsvpResponse} from '~/ViewInvitation/types/guests';
import {Button} from '~library/atoms/Button';

import * as styles from './FilterBy.module.scss';

const FilterButton = memo(
  ({filter, text, onClick}: {filter?: RsvpResponse; text: string; onClick: () => void}) => {
    const {
      state: {rsvpResponse},
    } = useGuestlistDataContext();
    return (
      <Button
        data-qa-id={`filter-by-${filter || 'all'}`}
        onClick={onClick}
        variant="transparent"
        className={cx(styles.button, {'button--active': filter === rsvpResponse})}
      >
        {text}
      </Button>
    );
  }
);

FilterButton.displayName = 'FilterButton';

export const FilterBy = memo(() => {
  const {
    state: {summary, query},
    dispatch,
  } = useGuestlistDataContext();

  const applyFilter = useCallback(
    (filter?: RsvpResponse) => {
      return () => {
        filterGuests(dispatch, filter);
      };
    },
    [dispatch]
  );

  if (query) return null;

  return (
    <div className={styles.container}>
      <FilterButton filter={undefined} text="All guests" onClick={applyFilter()} />
      <FilterButton filter="yes" text={`Yes (${summary?.yes})`} onClick={applyFilter('yes')} />
      <FilterButton
        filter="maybe"
        text={`Maybe (${summary?.maybe})`}
        onClick={applyFilter('maybe')}
      />
      <FilterButton filter="no" text={`No (${summary?.no})`} onClick={applyFilter('no')} />
      <FilterButton
        filter="undecided"
        text={`No reply (${summary?.noReply})`}
        onClick={applyFilter('undecided')}
      />
    </div>
  );
});

FilterBy.displayName = 'FilterBy';
